import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray,
  ValidatorFn
} from "@angular/forms";
import { AwsService } from "../../../providers/appsyncservice/aws.service";
import { UserTypePipePipe } from "../../../pipes/user-type-pipe.pipe";
import { positions } from "../../../models/positions";
declare var google: any;
import * as XLSX from "xlsx";
import * as jsPDF from "jspdf";
import { of } from "rxjs";

@Component({
  selector: "app-assign-user",
  templateUrl: "./assign-user.component.html",
  styleUrls: ["./assign-user.component.css"]
})
export class AssignUserComponent implements OnInit {
  displayUserValue: Number = 0;
  assignUserList: any = [];
  emp_Data: any = [];
  assignUserFm: FormGroup;
  submitted = false;
  mode: any;
  checkboxCount = false;
  isValid: any = true;
  errorMessage: any;
  ordersData = [];
  statusData: any = [
    { id: 1, name: "ACTIVE" },
    { id: 2, name: "INACTIVE" }
  ];

  sortKey: string = 'sno'; //set default
  sortReverse: boolean = false;

  noOfItems=10;
  
  constructor(
    public awserviceProvider: AwsService,
    private formBuilder: FormBuilder
  ) {
    this.getAllData();
  }

  // GET DATA FROM ASSIGNED USER
  getAllData() {
    console.log("GET CAR LIST");
    this.assignUserList=[]
    this.awserviceProvider.getAssignUserList().then(data => {
      this.constructData(data);
      console.log("response", data);
    });
  }

  constructData(data){
    this.assignUserList=[]
    var oplist=[]
    for(var i in data){
      data[i].sno=+i+1;
      oplist.push(data[i])
    }
    this.assignUserList=oplist;
  }

  searchRnId() {
    if (this.assignUserFm.value.rn_num !== "") {
      this.awserviceProvider
        .filterRnUserExist(this.assignUserFm.value.rn_num)
        .then(result => {
          console.log("RnExist", result.length);
          if (result.length === 0) {
            this.rnIdSearch();
            this.isValid = false;
          } else {
            this.emp_Data = [];
            this.isValid = true;
            this.errorMessage = "User already Exists!";
          }
        })
        .catch(err => {
          console.log("err", err);
        });
    } else {
      this.errorMessage = "Please Enter RN Number...";
    }
  }

  rnIdSearch() {
    this.emp_Data = [];
    console.log("searching.....", this.assignUserFm.value.rn_num);
    this.awserviceProvider
      .rnUserFilter(this.assignUserFm.value.rn_num)
      .then(result => {
        console.log("data-rn-user", result);
        if (result.length === 0) {
          this.errorMessage = "Please Enter Valid RN Number...";
        } else {
          this.errorMessage = "";
          this.emp_Data = result;
          console.log("ORDERS", this.ordersData);
          this.assignUserFm.patchValue({
            id: "",
            rn_num: this.emp_Data[0].user_name,
            user_name: this.emp_Data[0].user_name,
            name: this.emp_Data[0].name,
            email: this.emp_Data[0].email_address,
            phone: this.emp_Data[0].employee_phone,
            assign_mode: "",
            status: ""
          });
        }
      })
      .catch(err => {
        console.log("err", err);
      });
  }

  // ADD DATA
  add() {
    this.isValid = true;
    this.errorMessage = "";
    this.displayUserValue = 1;
    this.mode = "add";
    this.emp_Data = [];
    this.formInitilization();
    console.log("this.assignUserFm.value", this.assignUserFm.value);
  }

  formInitilization() {
    console.log("formInitilization");
    this.assignUserFm = this.formBuilder.group({
      id: [""],
      rn_num: [""],
      user_name: [""],
      name: [""],
      email: [""],
      phone: [""],
      status: ["", [Validators.required, Validators.min(1)]],
      // orders: new FormArray([])
      orders: new FormArray([], this.minSelectedCheckboxes(1))
    });
    of(this.getOrders()).subscribe(orders => {
      this.ordersData = orders;
      this.addCheckboxes();
    });
  }

  minSelectedCheckboxes(min = 1) {
    const validators: ValidatorFn = (formArray: FormArray) => {
      const totalSelected = formArray.controls
        // get a list of checkbox values (boolean)
        .map(control => control.value)
        // total up the number of checked checkboxes
        .reduce((prev, next) => (next ? prev + next : prev), 0);

      if (totalSelected === 0) {
        this.checkboxCount = true;
      } else {
        this.checkboxCount = false;
      }
      // if the total is not greater than the minimum, return the error message
      return totalSelected >= min ? null : { required: true };
    };
    console.log("thiru", validators);
    return validators;
  }

  get f() {
    return this.assignUserFm.controls;
  }

  editformInitilization() {
    console.log("formInitilization");
    // this.assignUserFm = new FormGroup({
    //   id: new FormControl(""),
    //   rn_num: new FormControl(""),
    //   user_name: new FormControl(""),
    //   name: new FormControl(""),
    //   email: new FormControl(""),
    //   phone: new FormControl(""),
    //   // assign_mode: new FormControl(""),
    //   status: new FormControl(""),
    //   orders: new FormArray([])
    // });
    this.assignUserFm = this.formBuilder.group({
      id: [""],
      rn_num: [""],
      user_name: [""],
      name: [""],
      email: [""],
      phone: [""],
      status: ["", [Validators.required, Validators.min(1)]],
      // orders: new FormArray([])
      orders: new FormArray([], this.minSelectedCheckboxes(1))
    });
    of(this.getOrders()).subscribe(orders => {
      this.ordersData = orders;
    });
  }

  getOrders() {
    return [
      { id: "CAR_MAINTENANCE", name: "Car Maintenance" },
      { id: "DRIVER_FEEDBACK", name: "Driver Feedback" },
      { id: "HOUSE_MAINTENANCE", name: "House Maintenance" },
      { id: "HOUSE_RELOCATION", name: "House Relocation" },
      { id: "DRIVER_ATTENDANCE", name: "Drive Attendance" },
    ];
  }

  addCheckboxes() {
    this.ordersData.forEach((o, i) => {
      console.log("0", o.id);
      // const control = new FormControl(i === 0); // if first item set to true, else false
      (this.assignUserFm.controls.orders as FormArray).push(
        new FormControl(false)
      );
    });
  }

  /* On Submit */
  // SAVE DATA
  onSubmit() {
    console.log("save btn clicked");
    console.log("onSubmit.....", this.assignUserFm.value);

    this.submitted = true;
    if (this.assignUserFm.invalid) {
      return;
    }

    this.errorMessage = "";
    const selectedOrderIds = this.assignUserFm.value.orders
      .map((v, i) => (v ? this.ordersData[i].id : null))
      .filter(v => v !== null);
    console.log("selectedOrderIds", selectedOrderIds);

    if (this.assignUserFm.value.id !== "") {
      // UPDATE
      console.log("update");
      var test2 = {
        id: this.assignUserFm.value.id,
        user_name: this.assignUserFm.value.user_name,
        name: this.assignUserFm.value.name,
        email: this.assignUserFm.value.email,
        phone: this.assignUserFm.value.phone,
        //assign_mode: this.assignUserFm.value.assign_mode,
        assign_mode: selectedOrderIds,
        status: this.assignUserFm.value.status
      };

      // # UPDATE RECORD #
      this.awserviceProvider
        .userAssignData(test2)
        .then(result => {
          this.findByIdRncUser(result.user_name);
          // this.sendEmail(result);
          // this.getAllData();
          // this.displayUserValue = 0;
          // this.mode = "";
          // this.isValid = true;
          // console.log("update-result", result);
        })
        .catch(err => {
          console.log("err", err);
        });
    } else {
      // CREATE
      var test1 = {
        user_name: this.assignUserFm.value.user_name,
        name: this.assignUserFm.value.name,
        email: this.assignUserFm.value.email,
        phone: this.assignUserFm.value.phone,
        // assign_mode: this.assignUserFm.value.assign_mode,
        assign_mode: selectedOrderIds,
        status: this.assignUserFm.value.status
      };

      // # CREATE RECORD #
      this.awserviceProvider
        .CreateUserAssign(test1)
        .then(resultData => {
          this.findByIdRncUser(resultData.user_name);
          // this.sendEmail(resultData); // email feature remove temporarily
          // this.getAllData();
          // this.displayUserValue = 0;
          // this.mode = "";
          // this.isValid = true;
          // console.log("resultData-test", resultData);
        })
        .catch(err => {
          console.log("err", err);
        });
    }
  }
  /* On Submit */

  sendEmail(data) {
    console.log("tttttttttttttttt", data.assign_mode);
    var text = "";
    this.ordersData
      .filter(temp => data.assign_mode.includes(temp.id))
      .forEach(res => {
        text += "<li>" + res.name + "</li>";
      });
    // for (var i = 0; i < this.ordersData.length; i++) {
    //   var test = data.assign_mode.includes(this.ordersData[i].id);
    //   if (test) {
    //     text += "<li>" + this.ordersData[i].name + "</li>";
    //   }
    // }
    console.log(text);
    var dataValue = {
      email_address: data.email,
      name:data.name,
      mode: text
    };
    this.awserviceProvider.sendEmailService(dataValue).subscribe(
      data => {
        console.log("data", data);
        // alert("Succesfully Sent Email");
      },
      Error => {
        console.log("Error", Error);
        // alert("failed while Sending Email");
      }
    );
  }

  editData(userdata) {
    console.log("userdata", userdata);
    this.displayUserValue = 1;
    this.submitted = false;
    this.mode = "edit";
    this.isValid = false;
    this.errorMessage = "";
    this.editformInitilization();
    /* checkbox Value */
    this.ordersData.map(localCheckBox => {
      console.log("localCheckBox", localCheckBox.id);
      if (userdata.assign_mode.includes(localCheckBox.id)) {
        (this.assignUserFm.controls.orders as FormArray).push(
          new FormControl(true)
        );
      } else {
        (this.assignUserFm.controls.orders as FormArray).push(
          new FormControl(false)
        );
      }
    });
    /* checkbox Value */

    this.assignUserFm.patchValue({
      id: userdata.id,
      rn_num: "",
      user_name: userdata.user_name,
      name: userdata.name,
      email: userdata.email,
      phone: userdata.phone,
      assign_mode: userdata.assign_mode,
      status: userdata.status
    });

    // this.f["id"].setValue(vendorDt.id);
    // this.f["name"].setValue(vendorDt.name);
    // this.f["email"].setValue(vendorDt.email);
    // this.f["phone"].setValue(vendorDt.phone);
    // this.f["address"].setValue(vendorDt.address);
    // this.f["vendor_type"].setValue(vendorDt.vendor_type);
    // this.f["is_active"].setValue(vendorDt.is_active);
    // console.log("pop", this.assignUserFm);
  }

  findByIdRncUser(user_name) {
    this.awserviceProvider
      .findUserByUserName(user_name)
      .then(result => {
        console.log("THIRU", result);
        this.updateRnUser(result[0].id);
      })
      .catch(err => {
        console.log("findByIdRncUser-err", err);
      });
  }
  updateRnUser(id) {
    console.log("pid", id);
    var id = id;
    var user_type = 6;
    this.awserviceProvider
      .updateRncUserAssignType(id, user_type)
      .then(res => {
        console.log("updateRnUser", res);
        this.getAllData();
        this.displayUserValue = 0;
        this.mode = "";
        this.isValid = true;
      })
      .catch(err => {
        console.log("updateRnUser-err", err);
      });
  }

  ngOnInit() {
    this.displayUserValue = 0;
    this.mode = "";
    this.formInitilization();
  }

  public sort(sortKey){
    this.sortKey = sortKey;
    this.sortReverse = !this.sortReverse;
  }

  public sortClass(sortKey){
    if(this.sortKey==sortKey){
      if(this.sortReverse){
        return 'fa fa-sort-desc';
      }
      else
      {
        return 'fa fa-sort-asc';
      }
    }
    else{
      return 'fa fa-sort';
    }
    
  }

}
